module.exports = __webpack_public_path__ + "img/logo-img-inv.a8b8df52.png";